﻿import { Controller } from "@hotwired/stimulus";
import { qrcanvas } from "qrcanvas";

export default class extends Controller {
    static get values() {
        return {
            sendCodeUrl: String,
            resendCode: String,
            otpSecret: String
        };
    }

    static get targets() {
        return [
            "smsAuthenticationMethodForm",
            "sendCodeButton",
            "sendCodeSuccessfulMessage",
            "sendCodeFailedMessage",
            "smsTwoFACode",
            "appAuthenticationMethodForm",
            "qrCode",
            "setUpAgain"
        ];
    }

    displaySelectedAuthenticationMethodForm({ target }) {
        if (this.hasSmsAuthenticationMethodFormTarget) {
            this.smsAuthenticationMethodFormTarget.classList.toggle("d-none", target.value !== "SMS");
        }

        this.appAuthenticationMethodFormTarget.classList.toggle("d-none", target.value !== "App");
    }

    async sendCode() {
        this.sendCodeButtonTarget.disabled = true;
        this.sendCodeSuccessfulMessageTarget.classList.add("d-none");
        this.sendCodeFailedMessageTarget.classList.add("d-none");
        const response = await fetch(this.sendCodeUrlValue, { method: "post" });
        const { wasSuccessful } = await response.json();
        this.sendCodeSuccessfulMessageTarget.classList.toggle("d-none", !wasSuccessful);
        this.sendCodeFailedMessageTarget.classList.toggle("d-none", wasSuccessful);
        this.smsTwoFACodeTarget.focus();
        setTimeout(
            () => {
                this.sendCodeButtonTarget.textContent = this.resendCodeValue;
                this.sendCodeButtonTarget.disabled = false;
            },
            5000
        );
    }

    displaySetUpAgain(e) {
        e.preventDefault();
        this.setUpAgainTarget.classList.remove("d-none");
        e.target.remove();
    }

    qrCodeTargetConnected() {
        this.qrCodeTarget.appendChild(qrcanvas({
            data: `otpauth://totp/?secret=${this.otpSecretValue}`,
            size: 200
        }));
    }
}